import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Tiktok24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
  >
    <path d="M 20.2 10.4 V 7.2 c 0 0 -1.7 0 -3.1 -1.3 c -1.3 -1.1 -1.4 -3.2 -1.4 -3.2 h -3.2 c 0 0 0 11 0 12.7 S 11 18 9.9 18 c -0.8 0 -2.7 -0.7 -2.7 -2.6 c 0 -2.2 2.2 -2.6 2.7 -2.6 s 0.8 0.1 0.8 0.1 V 9.5 c 0 0 -0.6 -0.1 -0.9 -0.1 c -3.2 -0.1 -5.9 2.8 -5.9 6 c 0 2.7 2.1 6 6 6 c 4.2 0 6 -3.5 6 -5.9 c 0 -1.9 0 -6.3 0 -6.3 s 1.1 0.6 2 0.9 C 19 10.4 20.2 10.4 20.2 10.4 Z"></path>
  </svg>
);

export default Tiktok24;
